export const HEADER_FIXED = "HEADER_FIXED";
export const HEADER_REMOVED = "HEADER_REMOVED";
export const HEADER_FAILED = "HEADER_FAILED";